var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Texte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10.476562 5.9785156 A 1.50015 1.50015 0 0 0 9 7.5 L 9 8.2539062 A 1.50015 1.50015 0 0 0 9 8.7402344 L 9 9.5 A 1.50015 1.50015 0 0 0 11.919922 10 L 22.5 10 L 22.5 39 L 20.5 39 A 1.50015 1.50015 0 1 0 20.5 42 L 23.753906 42 A 1.50015 1.50015 0 0 0 24.240234 42 L 27.5 42 A 1.50015 1.50015 0 1 0 27.5 39 L 25.5 39 L 25.5 10 L 36.080078 10 A 1.50015 1.50015 0 0 0 39 9.5 L 39 8.7460938 A 1.50015 1.50015 0 0 0 39 8.2597656 L 39 7.5 A 1.50015 1.50015 0 0 0 36.080078 7 L 24.246094 7 A 1.50015 1.50015 0 0 0 23.759766 7 L 11.919922 7 A 1.50015 1.50015 0 0 0 10.476562 5.9785156 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Texte);
export default __webpack_public_path__ + "static/media/icons8-texte.e641cd136e17306c3cfd5d8cacbea32d.svg";
export { ForwardRef as ReactComponent };